import PostsSerializer from '../base';

export default class Page extends PostsSerializer {
  payloadKeyFromModelName(modelName) {
    return super
      .payloadKeyFromModelName(modelName)
      .replace(/^posts\/templates\/page/, 'template');
  }

  modelNameFromPayloadKey(key) {
    return super.modelNameFromPayloadKey(
      'templates/' + key.replace('template', 'page'),
    );
  }
}
